import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from './environments/environment';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';



// Bootstrap the application
bootstrapApplication(AppComponent, appConfig)
